<div class="user-card">
  <app-avatar [name]="username()" [src]="photo()" class="pointer" [title]="username()" />

  @if (!collapsed()) {
    <div class="user-card__info">
      <span class="user-card__name body-sm-regular">{{ username() }}</span>
      <span class="user-card__role caption-regular">{{ email() }}</span>
    </div>
    <app-icon-button
      icon="icons/phosphor/regular/sign-out.svg"
      [size]="20"
      [label]="'user.logout' | transloco"
      (click)="logoutClick.emit()"
    >
    </app-icon-button>
  }
</div>
